import { FC, useCallback } from 'react'
import { useStoreDispatch } from 'helpers/reactReduxHelpers'
import { toggleCarEditActionCreator } from 'actions/settingsActions'
import { NEW_PROPERTY_ID } from 'constants/member'
import { modifyFloatingPaneActionCreator } from 'actions/floatingPanesActions'

type CarEditHandlerProps = {
  carId?: number

}

export const CarEditHandler: FC<CarEditHandlerProps> = (props) => {
  const { children, carId } = props

  const dispatch = useStoreDispatch()
  const handleClick = useCallback(() => {
    dispatch(toggleCarEditActionCreator(carId || NEW_PROPERTY_ID))
    dispatch(modifyFloatingPaneActionCreator('car-edit', {
      carId,
    }))
  }, [dispatch, carId])

  return (
    <span onClick={ handleClick }>
      { children }
    </span>
  )
}
